import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const container = document.getElementById("platform-connections-container");
    const resultsContainer = document.getElementById("platform-connections-results");
    const connectionsButton = document.getElementById("dropdown-platform-connections-button");
    const connectionsMenu = document.getElementById("dropdown-platform-connections-menu");
    let loadingTimeout;

    if (container.dataset.path.match(/platform_connections/)) {
      fetchPlatformConnections();
    }

    connectionsButton.addEventListener("click", fetchPlatformConnections);

    async function fetchPlatformConnections() {
      if (resultsContainer.dataset.fetched === "true") {
        return;
      }

      const account_id = resultsContainer.dataset.accountId
      const selected_connection_id = resultsContainer.dataset.connectionId

      try {
        const response = await fetch(`/admin/accounts/${account_id}/platform_connections/menu_items`, {
          headers: { Accept: "application/json" }
        })
        const results = await response.json();

        clearTimeout(loadingTimeout);

        resultsContainer.innerHTML = results.map(result => {
          let selected = String(result[0]) === selected_connection_id

          return `
            <div>
              <a id="button-platform-connections-${result[1].toLowerCase().replace(" ", "-")}" href="/admin/accounts/${account_id}/platform_connections/${result[0]}" style="font-family:Space Grotesk" class="text-sm truncate overflow-hidden block w-full px-2 py-1 hover:text-gray-200 cursor-pointer rounded-lg ${selected ? "text-gray-100 bg-gray-900 pl-2" : "text-gray-400"}">
                • ${result[1]}
              </a>
            </div>
          `;
        }).join("");

        resultsContainer.dataset.fetched = "true";
        connectionsMenu.style.maxHeight = connectionsMenu.scrollHeight + "px";
      } catch (error) {
        clearTimeout(loadingTimeout);
        console.error("Platfrom connections fetch error:", error);
      }
    }
  }
}
